import { Module } from "wrapper6";
import Stickyfill from "stickyfilljs";

export default class Sticky extends Module {
  ready() {
    const STICKY_ELEMENTS = document.querySelectorAll('.sticky');
    Stickyfill.add(STICKY_ELEMENTS);
  }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_sticky.js